import {
	IExtensionStayDetailStore,
	IWorkerAssignmentFranchiseListStore,
	IWorkerAssignmentListStore,
	IWorkerAssignmentPublicListStore,
	IWorkerChangeWorkPlaceDetailStore,
	IWorkerDocumentDetailStore,
	IWorkerSalaryDetailStore,
	IWorkerUnauthorizedDepartureListStore,
	TDefineDocumentAreaDetailStore,
} from '@/stores';

import { UserSettingScreenCodeEnum } from './common.constant';
import { RoutesNameEnum } from './router.constant';
import { SearchFilterTypes } from './search.constant';

export enum TableTypes {
	NOTICE = 'NOTICE',
	NOTICE_RECEIVE = 'NOTICE_RECEIVE',
	INQUIRY_BOARD = 'INQUIRY_BOARD',
	INQUIRY_BOARD_ANSWER = 'INQUIRY_BOARD_ANSWER',

	ED1_01 = 'ED1_01',
	UM1_01 = 'systemUser',
	AR1_01 = 'workerApplicant',
	AR1_03_RECOMMENDED = 'AM1_03_RECOMMENDED',
	AR1_03_LODGING = 'AR1_03_LODGING',
	MM1_01 = 'workerUser',
	LM1_01 = 'workerLodging',
	RM1_01 = 'workerRecommender',
	RM1_03_APPLICANT = 'RM1_03_APPLICANT',
	AM1_01 = 'AM1_01',
	AM1_03_APPLICANT = 'AM1_03_APPLICANT',
	AM3_01 = 'AM3_01',
	PA4_01 = 'workerSalary',
	FR1_01 = 'workerFranchise',
	FR1_03_ASSIGNED = 'WorkerFranchiseAssignment',
	FR1_03_LODGING = 'WorkerFranchiseLodging',
	FR1_03_PROGRAM = 'workerFranchiseProgram',
	DM1_01 = 'workerDocument',
	PM1_01 = 'workerProgram',
	PM2_01 = 'workerProgramStatus',
	PM1_03_APPLICANT = 'workerProgramApplicant',
	PM1_03_FRANCHISE = 'workerProgramFranchise',
	DEFINE_DOCUMENT_AREA = 'defineDocumentArea',
	BM1_01 = 'workerUnauthorizedDeparture',
	LM1_03_APPLICANT = 'LM1_03_APPLICANT',
	CM1_01 = 'systemUnit',
	WC1_01 = 'workerChangeWorkPlace',
	EM1_01 = 'workerExtensionStay',
	EM1_03_APPLICANT = 'workerExtensionStayApplicant',
	UPDATE_HISTORY = 'UPDATE_HISTORY',
	MSLP = 'MSLP',
	OI2_01 = 'OI2_01',
	OR1_01 = 'OR1_01',
	OP1_01 = 'OP1_01',
	FOOTER_INFO = 'footerInfo',
	DISTRICT_ALLOW_IP = 'districtAllowIp',
	CONTRACTED_FOREIGN_BUSINESS = 'CONTRACTED_FOREIGN_BUSINESS',
	OP1_03_APPLICANT = 'OP1_03_APPLICANT',
	CM2_01 = 'foreignSystemUnit',
	ST1_01 = 'workerUseTip',
	SM1_01 = 'systemUseTip',
	PA3_01 = 'workerPublicSalary',
	PA3_03_APPLICANT = 'PA3_03_APPLICANT',
	PA1_01 = 'workerAssignmentPublic',
	PA1_03_APPLICANT = 'PA1_03_APPLICANT',
	AU1_01 = 'workerAuditMonitoring',
	DEV_01 = 'deviceMobile',
	DEV_03 = 'deviceTablet',
	DEV_08 = 'deviceLog',
}

export type TableValuesMap = {
	[TableTypes.PA4_01]: IWorkerSalaryDetailStore;
	[TableTypes.DM1_01]: IWorkerDocumentDetailStore;
	[TableTypes.AM1_01]: IWorkerAssignmentFranchiseListStore;
	[TableTypes.AM3_01]: IWorkerAssignmentListStore;
	[TableTypes.DEFINE_DOCUMENT_AREA]: TDefineDocumentAreaDetailStore;
	[TableTypes.BM1_01]: IWorkerUnauthorizedDepartureListStore;
	[TableTypes.WC1_01]: IWorkerChangeWorkPlaceDetailStore;
	[TableTypes.EM1_01]: IExtensionStayDetailStore;
	[TableTypes.PA1_01]: IWorkerAssignmentPublicListStore;
};

/**
 * @description For delete at list
 */
export const TableNameMap = {
	[TableTypes.NOTICE]: RoutesNameEnum.NM1_01,
	[TableTypes.NOTICE_RECEIVE]: RoutesNameEnum.NP1_01,
	[TableTypes.INQUIRY_BOARD]: RoutesNameEnum.BB1_01,
	[TableTypes.INQUIRY_BOARD_ANSWER]: RoutesNameEnum.BBM1_01,

	[TableTypes.ED1_01]: RoutesNameEnum.AR1_01,
	[TableTypes.UM1_01]: RoutesNameEnum.UM1_01,
	[TableTypes.MM1_01]: RoutesNameEnum.MM1_01,
	[TableTypes.AR1_01]: RoutesNameEnum.AR1_01,
	[TableTypes.AR1_03_RECOMMENDED]: RoutesNameEnum.AR1_01,
	[TableTypes.AR1_03_LODGING]: RoutesNameEnum.AR1_01,
	[TableTypes.LM1_01]: RoutesNameEnum.LM1_01,
	[TableTypes.RM1_01]: RoutesNameEnum.RM1_01,
	[TableTypes.RM1_03_APPLICANT]: RoutesNameEnum.RM1_01,
	[TableTypes.PA1_01]: RoutesNameEnum.PA1_01,
	[TableTypes.PA1_03_APPLICANT]: RoutesNameEnum.PA1_01,
	[TableTypes.PA4_01]: RoutesNameEnum.PA4_01,
	[TableTypes.FR1_01]: RoutesNameEnum.FR1_01,
	[TableTypes.FR1_03_LODGING]: RoutesNameEnum.FR1_01,
	[TableTypes.FR1_03_ASSIGNED]: RoutesNameEnum.FR1_01,
	[TableTypes.FR1_03_PROGRAM]: RoutesNameEnum.FR1_01,
	[TableTypes.DM1_01]: RoutesNameEnum.DM1_01,
	[TableTypes.PM1_01]: RoutesNameEnum.SUB_PM,
	[TableTypes.PM1_03_APPLICANT]: RoutesNameEnum.SUB_PM,
	[TableTypes.PM1_03_FRANCHISE]: RoutesNameEnum.SUB_PM,
	[TableTypes.PM2_01]: RoutesNameEnum.SUB_PM,
	[TableTypes.AM1_01]: RoutesNameEnum.SUB_AM,
	[TableTypes.AM1_03_APPLICANT]: RoutesNameEnum.SUB_AM,
	[TableTypes.AM3_01]: RoutesNameEnum.SUB_AM,
	[TableTypes.DEFINE_DOCUMENT_AREA]: RoutesNameEnum.DOCUMENT_AREA,
	[TableTypes.BM1_01]: RoutesNameEnum.BM1_01,
	[TableTypes.LM1_03_APPLICANT]: RoutesNameEnum.LM1_01,
	[TableTypes.CM1_01]: RoutesNameEnum.CM1_01,
	[TableTypes.WC1_01]: RoutesNameEnum.WC1_01,
	[TableTypes.EM1_01]: RoutesNameEnum.EM1_01,
	[TableTypes.EM1_03_APPLICANT]: RoutesNameEnum.EM1_01,
	[TableTypes.UPDATE_HISTORY]: '',
	[TableTypes.MSLP]: '',
	[TableTypes.OI2_01]: RoutesNameEnum.OI2_01,
	[TableTypes.OR1_01]: RoutesNameEnum.OR1_01,
	[TableTypes.OP1_01]: RoutesNameEnum.OP1_01,
	[TableTypes.FOOTER_INFO]: RoutesNameEnum.FOOTER_INFO,
	[TableTypes.DISTRICT_ALLOW_IP]: RoutesNameEnum.DISTRICT_ALLOW_IP,
	[TableTypes.CONTRACTED_FOREIGN_BUSINESS]:
		RoutesNameEnum.CONTRACTED_FOREIGN_BUSINESS,
	[TableTypes.OP1_03_APPLICANT]: RoutesNameEnum.OP1_01,
	[TableTypes.CM2_01]: RoutesNameEnum.CM2_01,
	[TableTypes.ST1_01]: RoutesNameEnum.ST1_01,
	[TableTypes.SM1_01]: RoutesNameEnum.SM1_01,
	[TableTypes.PA3_01]: RoutesNameEnum.PA3_01,
	[TableTypes.PA3_03_APPLICANT]: RoutesNameEnum.PA3_03,
	[TableTypes.AU1_01]: RoutesNameEnum.AU1_01,
	[TableTypes.DEV_01]: RoutesNameEnum.DEV_01,
	[TableTypes.DEV_03]: RoutesNameEnum.DEV_03,
	[TableTypes.DEV_08]: RoutesNameEnum.DEV_08,
};

export const TableSettingColumnSubTypeMap: Record<
	TableTypes,
	UserSettingScreenCodeEnum
> = {
	[TableTypes.ED1_01]: UserSettingScreenCodeEnum.AR1,
	[TableTypes.AR1_01]: UserSettingScreenCodeEnum.AR1,
	[TableTypes.LM1_01]: UserSettingScreenCodeEnum.LM1,
	[TableTypes.RM1_01]: UserSettingScreenCodeEnum.RM1,
	[TableTypes.PA4_01]: UserSettingScreenCodeEnum.PA4,
	[TableTypes.FR1_01]: UserSettingScreenCodeEnum.FR1,
	[TableTypes.DM1_01]: UserSettingScreenCodeEnum.DM1,
	[TableTypes.PM1_01]: UserSettingScreenCodeEnum.PM1,
	[TableTypes.PM2_01]: UserSettingScreenCodeEnum.PM2,
	[TableTypes.AM1_01]: UserSettingScreenCodeEnum.AM1,
	[TableTypes.AM3_01]: UserSettingScreenCodeEnum.AM3,
	[TableTypes.BM1_01]: UserSettingScreenCodeEnum.BM1,
	[TableTypes.WC1_01]: UserSettingScreenCodeEnum.WC1,
	[TableTypes.EM1_01]: UserSettingScreenCodeEnum.EM1,
	[TableTypes.OI2_01]: UserSettingScreenCodeEnum.OI2,
	[TableTypes.OR1_01]: UserSettingScreenCodeEnum.OR1,
	[TableTypes.OP1_01]: UserSettingScreenCodeEnum.OP1,
	[TableTypes.PA1_01]: UserSettingScreenCodeEnum.PA1,

	// type not use
	[TableTypes.UM1_01]: undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.CM1_01]: undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.MM1_01]: undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.NOTICE]: undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.NOTICE_RECEIVE]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.INQUIRY_BOARD]: undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.INQUIRY_BOARD_ANSWER]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.AM1_03_APPLICANT]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.FR1_03_ASSIGNED]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.FR1_03_LODGING]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.FR1_03_PROGRAM]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.PM1_03_APPLICANT]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.PM1_03_FRANCHISE]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.DEFINE_DOCUMENT_AREA]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.LM1_03_APPLICANT]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.EM1_03_APPLICANT]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.UPDATE_HISTORY]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.RM1_03_APPLICANT]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.AR1_03_RECOMMENDED]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.AR1_03_LODGING]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.MSLP]: undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.FOOTER_INFO]: undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.DISTRICT_ALLOW_IP]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.CONTRACTED_FOREIGN_BUSINESS]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.OP1_03_APPLICANT]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.CM2_01]: undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.ST1_01]: undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.SM1_01]: undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.PA3_01]: undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.PA3_03_APPLICANT]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.PA1_03_APPLICANT]:
		undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.AU1_01]: undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.DEV_01]: undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.DEV_03]: undefined as unknown as UserSettingScreenCodeEnum,
	[TableTypes.DEV_08]: undefined as unknown as UserSettingScreenCodeEnum,
};

export const TableSearchTypeMap: Record<TableTypes, SearchFilterTypes> = {
	[TableTypes.ED1_01]: SearchFilterTypes.AR1_01,
	[TableTypes.AR1_01]: SearchFilterTypes.AR1_01,
	[TableTypes.LM1_01]: SearchFilterTypes.LM1_01,
	[TableTypes.RM1_01]: SearchFilterTypes.RM1_01,
	[TableTypes.PA4_01]: SearchFilterTypes.PA4_01,
	[TableTypes.FR1_01]: SearchFilterTypes.FR1_01,
	[TableTypes.DM1_01]: SearchFilterTypes.DM1_01,
	[TableTypes.PM1_01]: SearchFilterTypes.PM1_01,
	[TableTypes.PM2_01]: SearchFilterTypes.PM2_01,
	[TableTypes.AM1_01]: SearchFilterTypes.AM1_01,
	[TableTypes.AM3_01]: SearchFilterTypes.AM3_01,
	[TableTypes.BM1_01]: SearchFilterTypes.BM1_01,
	[TableTypes.WC1_01]: SearchFilterTypes.WC1_01,
	[TableTypes.EM1_01]: SearchFilterTypes.EM1_01,
	[TableTypes.OI2_01]: SearchFilterTypes.OI2_01,
	[TableTypes.OR1_01]: SearchFilterTypes.OR1_01,
	[TableTypes.OP1_01]: SearchFilterTypes.OP1_01,
	[TableTypes.PA3_01]: SearchFilterTypes.PA3_01,
	[TableTypes.PA1_01]: SearchFilterTypes.PA1_01,
	[TableTypes.AU1_01]: SearchFilterTypes.AU1_01,
	[TableTypes.DEV_01]: SearchFilterTypes.DEV_01,
	[TableTypes.DEV_03]: SearchFilterTypes.DEV_03,
	[TableTypes.DEV_08]: SearchFilterTypes.DEV_08,

	// type not use
	[TableTypes.UM1_01]: undefined as unknown as SearchFilterTypes,
	[TableTypes.CM1_01]: undefined as unknown as SearchFilterTypes,
	[TableTypes.MM1_01]: undefined as unknown as SearchFilterTypes,
	[TableTypes.NOTICE]: undefined as unknown as SearchFilterTypes,
	[TableTypes.NOTICE_RECEIVE]: undefined as unknown as SearchFilterTypes,
	[TableTypes.INQUIRY_BOARD]: undefined as unknown as SearchFilterTypes,
	[TableTypes.INQUIRY_BOARD_ANSWER]: undefined as unknown as SearchFilterTypes,
	[TableTypes.AM1_03_APPLICANT]: undefined as unknown as SearchFilterTypes,
	[TableTypes.FR1_03_ASSIGNED]: undefined as unknown as SearchFilterTypes,
	[TableTypes.FR1_03_LODGING]: undefined as unknown as SearchFilterTypes,
	[TableTypes.FR1_03_PROGRAM]: undefined as unknown as SearchFilterTypes,
	[TableTypes.PM1_03_APPLICANT]: undefined as unknown as SearchFilterTypes,
	[TableTypes.PM1_03_FRANCHISE]: undefined as unknown as SearchFilterTypes,
	[TableTypes.DEFINE_DOCUMENT_AREA]: undefined as unknown as SearchFilterTypes,
	[TableTypes.LM1_03_APPLICANT]: undefined as unknown as SearchFilterTypes,
	[TableTypes.EM1_03_APPLICANT]: undefined as unknown as SearchFilterTypes,
	[TableTypes.UPDATE_HISTORY]: undefined as unknown as SearchFilterTypes,
	[TableTypes.RM1_03_APPLICANT]: undefined as unknown as SearchFilterTypes,
	[TableTypes.AR1_03_RECOMMENDED]: undefined as unknown as SearchFilterTypes,
	[TableTypes.AR1_03_LODGING]: undefined as unknown as SearchFilterTypes,
	[TableTypes.MSLP]: undefined as unknown as SearchFilterTypes,
	[TableTypes.FOOTER_INFO]: undefined as unknown as SearchFilterTypes,
	[TableTypes.DISTRICT_ALLOW_IP]: undefined as unknown as SearchFilterTypes,
	[TableTypes.CONTRACTED_FOREIGN_BUSINESS]:
		undefined as unknown as SearchFilterTypes,
	[TableTypes.OP1_03_APPLICANT]: undefined as unknown as SearchFilterTypes,
	[TableTypes.CM2_01]: undefined as unknown as SearchFilterTypes,
	[TableTypes.ST1_01]: undefined as unknown as SearchFilterTypes,
	[TableTypes.SM1_01]: undefined as unknown as SearchFilterTypes,
	[TableTypes.PA3_03_APPLICANT]: undefined as unknown as SearchFilterTypes,
	[TableTypes.PA1_03_APPLICANT]: undefined as unknown as SearchFilterTypes,
};

export type FormikValues = {
	[key: string | number | symbol]: any;
};
